import * as React from "react";
import clsx from "clsx";

import { IMAGE_TYPE } from "../../../Definition";

import styles from "./ImagePageView.module.scss";

const HORIZONTAL_CORE_RATE = 0.78;

export interface ImagePageViewProps {
  imageUrl: string;
  imageType?: number;
  page: number;
  isGuideline?: boolean;
  outerSize: { width: number; height: number };
}
export const ImagePageView = (props: ImagePageViewProps) => {
  const imageRef = React.useRef<HTMLImageElement>(null);
  const [imageSize, setImageSize] = React.useState({ width: 0, height: 0 });

  const isHorizontalImage = props.imageType === IMAGE_TYPE.horizontal;
  const [isHorizontalScreen, setIsHorizontalScreen] = React.useState(false);

  const setContentPosition = () => {
    if (imageRef.current!.naturalWidth < 1) {
      return;
    }
    setImageSize({
      width: imageRef.current!.naturalWidth,
      height: imageRef.current!.naturalHeight,
    });
  };

  React.useEffect(() => {
    if (imageSize.width < 1) {
      return;
    }
    const coreHeight = isHorizontalImage
      ? imageSize.height * HORIZONTAL_CORE_RATE
      : imageSize.height;

    const wrapperWidth = props.outerSize.width;
    const wrapperHeight = props.outerSize.height;

    if (wrapperWidth / imageSize.width > wrapperHeight / coreHeight) {
      // Horizontal Screen
      setIsHorizontalScreen(true);
    } else {
      // Vertical Screen
      setIsHorizontalScreen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageSize, props.outerSize]);

  return (
    <div
      className={clsx(
        styles.wrapper,
        props.isGuideline && styles.wrapper__modify,
      )}
    >
      <img
        className={clsx(
          styles.image,
          isHorizontalScreen
            ? styles.horizontalContents
            : styles.verticalContents,
          isHorizontalImage && styles.horizontalImage,
        )}
        ref={imageRef}
        src={props.imageUrl}
        alt={`lesson-${props.page}`}
        onLoad={setContentPosition}
      />
    </div>
  );
};
export default ImagePageView;
